import {useLocation} from 'react-router-dom';

/** Slug статьи из URL /docs или /docs/guides/editor (только pathname — надёжнее useParams). */
export function useDocSlugFromUrl(): string {
  const {pathname} = useLocation();
  const match = pathname.match(/^\/docs\/?(.*)$/);
  if (!match) {
    return '';
  }

  const rest = (match[1] ?? '').replace(/\.md$/i, '');
  return rest ? rest.split('/').map(decodeURIComponent).join('/') : '';
}
